import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Select, Typography } from 'antd'

const { Text, Title } = Typography
const { Option } = Select;

class SelectStatus extends Component {
	state = {
		file: undefined,
		phone: false,
	}

	onChange = async (e) => {
		let phonenumber = e.target.value
		let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
		if(re.test(e.target.value)){
			// await this.setState({phone:true})
			// await this.props.onChangePhone(phonenumber)
		}
		else if (!e.target.value) {
			// this.props.onChangePhone(false)
		}
		else{	
			// await this.setState({phone:false})
			// this.props.onChangePhone(null)
		}
	}

	onChangeText = async (e) =>{
		const { onChangeValueManageuser, name } = this.props
		onChangeValueManageuser(e.target.value, name)
	}

	// componentDidMount() {
	// 	let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
	// 	console.log("re.test('a')",re.test('11-,1a'));
	// }

	render() {
		const { values, required, name, label, mode, placeholder, onChangeInput = '' } = this.props
		const { getFieldDecorator } = this.props.form;

		return (
			<>
				<Form.Item label={label}>
                    { getFieldDecorator(name, {
                        initialValue: values,
                        rules:  [{ 
                            required: true, 
                            message: 'กรุณากรอกหรือเลือก '+label,
                        }],
                    })(
                        <Select  style={{ width: "100%" }}>
                            <Option value="jack">Jack</Option>
                        </Select>
                    )}
				</Form.Item>
			</>
		)
	}
}

SelectStatus.defaultProps = {
	autoFocus: false
}

SelectStatus.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedSelectStatus = Form.create()(SelectStatus)

export default withApollo(WrappedSelectStatus)